import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Paper, Button, IconButton, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, CircularProgress } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import propTypes from 'prop-types';
import { patchProposalProject } from 'ProposalProject/ProposalProject/Domain/Services/PatchProposalProjectService';
import { ProposalProjectConstants } from 'ProposalProject/ProposalProject/Domain/Model/ProposalProjectConstant';
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';
import { ADMIN_PROPOSAL_PROJECT } from 'Shared/Security/Application/Constants/PermissionsConstant';
import DialogLoader from 'UI/Application/Components/Loaders/DialogLoader';
import { deleteDocument } from 'Document/Domain/Services/DeleteDocumentService';
import { getDocument } from 'Document/Domain/Services/GetDocumentService';
import { toast } from 'react-toastify';

const FourthStep = ({
    idProposalProject,
    proposalProjectStatus,
    roiProposalProject,
    permissionsProposalProject,
    reloadData,
    readOnly = false,
    currentStatus,
    jiraEpicKey
}) => {
    const { checkPermission } = useAuthContext();

    const headerStyle = {
        backgroundColor: '#0492D4',
        color: 'white',
        textAlign: 'center',
        padding: '8px',
        fontWeight: 'bold',
    };

    const dataStyle = {
        textAlign: 'center',
        backgroundColor: '#f5f5f5',
    };

    const [documents, setDocuments] = useState([]);
    const [dataToDelete, setDataToDelete] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [sendingApiRequest, setSendingApiRequest] = useState(false);
    const [openDialogError, setOpenDialogError] = useState(false);
    const [generatingPdf, setGeneratingPdf] = useState(false);
    const [loadingRoi, setLoadingRoi] = useState(true);
    
    
    useEffect(() => {
        const fetchDocuments = async () => {
            try {
                const docs = await getDocument(idProposalProject, 'ProposalProject');
                const safeDocs = Array.isArray(docs) ? docs : [];
                const formattedDocs = safeDocs.map((doc) => ({
                    ...doc,
                    hidden: false,
                    documentNew: false,
                }));
                setDocuments(formattedDocs);
            } catch (e) {
                console.error('Error obteniendo documentos', e);
                setDocuments([]);
            }
        };

        fetchDocuments();
    }, [idProposalProject]);

    // Efecto para controlar cuando los datos del ROI están disponibles
    useEffect(() => {
        if (roiProposalProject && Object.keys(roiProposalProject).length > 0) {
            // Simular un pequeño retraso para asegurar que la UI muestre el loader
            setTimeout(() => {
                setLoadingRoi(false);
            }, 500);
        }
    }, [roiProposalProject]);

    // Filas y correspondencias con los datos del objeto
    const rows = [
        { label: 'Coste Total', key: 'total_cost' },
        { label: 'Total coste acumulativo', key: 'total_cost_accumulative' },
        { label: 'Beneficios totales', key: 'total_beneffits' },
        { label: 'Total beneficio acumulativo', key: 'total_accumulative_beneffits' },
        { label: 'Beneficio menos coste por año', key: 'beneffits_less_cost' },
        { label: 'ROI por año', key: 'roi_year' },
        { label: 'ROI por año (acumulativo)', key: 'roi_year_accumulative' },
    ];


    const handleApprove = async () => {
        var workflowResponse = await patchProposalProject(parseInt(idProposalProject), {
            workflowAction: ProposalProjectConstants.WORKFLOW_ADMIN_APPROVES
        });

        if (workflowResponse) {
            reloadData();
        }
    };

    
    const handleFinish = async () => {
        var workflowResponse = await patchProposalProject(parseInt(idProposalProject), {
            workflowAction: ProposalProjectConstants.WORKFLOW_PROJECT_FINISHED
        });

        if (workflowResponse) {
            reloadData();
        }
    };

    const handleSubmitDocReport = async (event) => {
        if (event && event.preventDefault) event.preventDefault();

        try {
            setSendingApiRequest(true);

            // Encuentra el archivo oculto que tenía ID (es el anterior)
            const deletedDoc = documents.find(doc => 
                doc.hidden &&
                doc.id &&
                (doc.fileName || doc.name) === `PR-${idProposalProject}_requerimientos_iniciales_cierre.docx`
            );


            if (deletedDoc) {
                await deleteDocument(deletedDoc.id);
            }

            const files = await Promise.all(
                documents
                    .filter(file => !file.hidden)
                    .map((file) => {
                        if (file.documentNew) {
                            return new Promise((resolve, reject) => {
                                const reader = new FileReader();
                                reader.onload = () =>
                                    resolve({
                                        name: file.name,
                                        data: reader.result,
                                        documentNew: true
                                    });
                                reader.onerror = (error) => reject(error);
                                reader.readAsDataURL(file);
                            });
                        }

                        return Promise.resolve({
                            name: file.name || file.fileName,
                            data: file.path || file.data,
                            documentNew: false
                        });
                    })
            );

            const response = await patchProposalProject(parseInt(idProposalProject), {
                status: 'reportClosed',
                documents: files
            });

            if (response) {
                toast.success('Archivo guardado correctamente.');
                window.location.reload();
            } else {
                toast.error('El archivo marcado como requerimiento inicial de cierre debe ser un documento Word (.docx).'); 
            }

        } catch (error) {
            toast.error('Error al guardar archivos.');
        } finally {
            setSendingApiRequest(false);
        }
    };



    // const handleApprove = async () => {
        
    //         // abrir en una nueva pestaña esto api/v1/proposal-project/${idProposalProject}/generate-word-test
    //     const downloadUrl = `/api/v1/proposal-project/${idProposalProject}/generate-word-test`;
    //     const link = document.createElement('a');
    //     link.href = downloadUrl;
    //     link.setAttribute('target', '_blank'); // Abrir en una nueva pestaña
    //     document.body.appendChild(link);
    //     link.click();
        
    // };


    // const downloadExcelClosed = async () => {
    //     alert('Descargando Excel cerrado');
    // };

    const handleReject = async () => {
        // Lógica para rechazar
        var workflowResponse = await patchProposalProject(parseInt(idProposalProject), {
            workflowAction: ProposalProjectConstants.WORKFLOW_ADMIN_REJECTS
        });
        if (workflowResponse) {
            reloadData();
        }
    };
    
    // Función para volver al paso anterior
    const handleBack = async () => {
        // Lógica para volver al paso anterior
        var workflowResponse = await patchProposalProject(parseInt(idProposalProject), {
            workflowAction: ProposalProjectConstants.WORKFLOW_STEP4_TO_STEP3
        });
        if (workflowResponse) {
            reloadData();
        }
    };

    // Add new handler for standby
    const handleStandby = async () => {
        var workflowResponse = await patchProposalProject(parseInt(idProposalProject), {
            workflowAction: ProposalProjectConstants.WORKFLOW_ADMIN_STANDBY
        });
        if (workflowResponse) {
            reloadData();
        }
    };

    // Add function to handle transition from standby back to step 4
    const handleBackToFlow = async () => {
        var workflowResponse = await patchProposalProject(parseInt(idProposalProject), {
            workflowAction: ProposalProjectConstants.WORKFLOW_ADMIN_STANDBY_TO_STEP4
        });
        if (workflowResponse) {
            reloadData();
        }
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (!selectedFile) return;

        setDocuments((prev) => {
            // Oculta el documento anterior visible
            const updated = prev.map((file) => ({
                ...file,
                hidden: true
            }));

            // Añade el nuevo archivo
            selectedFile.documentNew = true;
            selectedFile.hidden = false;
            selectedFile.tempId = `${selectedFile.name}_${selectedFile.lastModified}`;

            return [...updated, selectedFile];
        });
    };

    const handleDownloadPdfReport = async () => {
        try {
            setGeneratingPdf(true);
            const response = await fetch(`/api/v1/proposal-project/${idProposalProject}/generate-pdf-final-requirements`);
            
            if (response.headers.get('Content-Type')?.includes('application/pdf')) {
                // It's a PDF - download it
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `proposal-project-${idProposalProject}-final-requirements.pdf`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
            } else {
                // It's likely an error response
                const errorData = await response.json();
                toast.error(`Error al generar el PDF: ${errorData.message || 'Error desconocido'}`);
            }
        } catch (error) {
            toast.error('Error al generar el informe de cierre');
            console.error(error);
        } finally {
            setGeneratingPdf(false);
        }
    };

    // Cierra el dialog sin eliminar
    const handleCloseDialog = () => {
        setOpenDialog(false);
        setOpenDialogError(false);
        setDataToDelete(null);
    };

    const confirmDelete = (data, type) => {
        const dataWithType = { ...data, type: type, tempId: data.tempId };
        setDataToDelete(dataWithType);
        setOpenDialog(true);
    };


    const handleConfirmDelete = async () => {
        if (!dataToDelete) return;

        // Si es un archivo nuevo (no subido aún, sin ID)
        if (!dataToDelete.id) {
            setDocuments((prevDocuments) =>
                prevDocuments.filter((file) => file.tempId !== dataToDelete.tempId)
            );

            toast.success('Archivo eliminado correctamente');
            setOpenDialog(false);
            setDataToDelete(null);
            return;
        }

        // Si es un archivo subido
        setSendingApiRequest(true);
        try {
            const apiResponse = await deleteDocument(dataToDelete.id);
            if (apiResponse) {
                setDocuments((prevDocuments) =>
                    prevDocuments.filter((file) => file.id !== dataToDelete.id)
                );
                toast.success('Archivo eliminado correctamente');
            } else {
                toast.error('Error al eliminar el documento del servidor.');
            }
        } catch (error) {
            toast.error('Error al eliminar el documento.');
        } finally {
            setSendingApiRequest(false);
            setOpenDialog(false);
            setDataToDelete(null);
        }
    };


    const handleViewDocument = async (base64FileName) => {
        try {
            const fileURL = "/api/v1/blob-storage/" + base64FileName;
            window.open(fileURL, '_blank');
        } catch (error) {
            alert('No se pudo obtener el documento.');
        }
    };


    const renderButtons = (proposalProjectStatus) => {
        permissionsProposalProject = permissionsProposalProject || '';
        
        // If in readonly mode, show a message indicating the current view is read-only
        if (readOnly) {
            return (
                <>
                    {jiraEpicKey && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, mt: 2 }}>
                            <Button 
                                variant="contained" 
                                color="primary" 
                                href={`${process.env.REACT_APP_JIRA_BASE_URL}/browse/${jiraEpicKey}`} 
                                target="_blank"
                            >
                                Acceder al proyecto en JIRA: {jiraEpicKey}
                            </Button>
                        </Box>
                    )}
                    {proposalProjectStatus === ProposalProjectConstants.STATUS_FINISHED && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                            <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                                <Button 
                                    onClick={handleDownloadPdfReport}
                                    variant="contained" color='success' sx={{ fontWeight:'bold' }} >
                                    Descargar informe de cierre
                                </Button>
                            </Grid>
                        </Box>
                    )}
                    <Typography variant="h6" mt={4} color="textSecondary">
                    Vista en modo de solo lectura.
                    </Typography>
                    <Typography variant="h6" mt={4} color="textSecondary">
                        {currentStatus !== undefined && currentStatus && 
                        `La propuesta no está en este estado.`}
                    </Typography>
                </>
            );
        }

        // Original code for rendering buttons based on status
        let showComponents = (<></>);
        switch (proposalProjectStatus) {
            case ProposalProjectConstants.STATUS_STEP4:
                if (checkPermission(ADMIN_PROPOSAL_PROJECT)){
                    showComponents = (<>
                        {/* Botones */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-evenly', mt: 4 }}>
                            <Button variant="contained" color="success" sx={{ width: '150px', fontWeight: 'bold' }} onClick={handleApprove}>
                                Aceptar
                            </Button>
                            <Button variant="contained" sx={{ width: '150px', fontWeight: 'bold' }} onClick={handleBack}>
                                Volver
                            </Button>
                            <Button variant="contained" color="warning" sx={{ width: '150px', fontWeight: 'bold' }} onClick={handleStandby}>
                                Dejar en espera
                            </Button>
                            <Button variant="contained" color="error" sx={{ width: '150px', fontWeight: 'bold' }} onClick={handleReject}>
                                Rechazar
                            </Button>
                        </Box>
                    </>);
                } else {
                    showComponents = (
                        <Typography variant="h6" mt={4}>
                            Propuesta en revisión
                        </Typography>
                    );
                }
                break;
            case ProposalProjectConstants.STATUS_ACCEPTED:
                if (checkPermission(ADMIN_PROPOSAL_PROJECT)){
                    showComponents = (<>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                            <Button 
                                href={`/api/v1/proposal-project/${idProposalProject}/generate-word-final-requirements`}
                                target="_blank"
                                variant="contained" sx={{  backgroundColor:'orange'}} >
                                Descargar plantilla informe de cierre
                            </Button>
                            <Button variant="contained" component="label" sx={{ marginLeft: '10px' }}>
                                Subir Archivos
                                <input type="file" hidden multiple onChange={handleFileChange} />
                            </Button>   
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                            <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                                {documents
                                    .filter(doc =>
                                        !doc.hidden &&
                                        (
                                            (doc.fileName || doc.name) === `PR-${idProposalProject}_requerimientos_iniciales_cierre.docx` ||
                                            doc.documentNew === true
                                        )
                                    )
                                    .map((file) => (
                                        <Grid item key={file.id || file.tempId} xs={12} sm={6} md={4} lg={3}>
                                            <Paper sx={{ 
                                                p: 2, 
                                                position: 'relative', 
                                                textAlign: 'center',
                                                minHeight: '100px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                overflow: 'hidden'
                                            }}>
                                                <Typography variant="body2" sx={{ 
                                                    mb: 1, 
                                                    position: 'relative',
                                                    wordBreak: 'break-word',
                                                    width: '100%',
                                                    paddingRight: '28px'
                                                }}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        size="small"
                                                        style={{ 
                                                            marginTop: '10px',
                                                            maxWidth: '100%'
                                                        }}
                                                        onClick={() => handleViewDocument(file.path || file.name)}
                                                        title={file.fileName || file.name}
                                                        sx={{
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap'
                                                        }}
                                                    >
                                                        {(file.fileName || file.name).length > 20 
                                                            ? (file.fileName || file.name).substring(0, 17) + '...' 
                                                            : (file.fileName || file.name)
                                                        }
                                                    </Button>
                                                </Typography>
                                                <IconButton
                                                    sx={{ 
                                                        position: 'absolute', 
                                                        top: 5, 
                                                        right: 5,
                                                        zIndex: 2,
                                                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                        }
                                                    }}
                                                    onClick={() => confirmDelete(file, 'document')}
                                                >
                                                    <DeleteIcon color="error" />
                                                </IconButton>
                                            </Paper>
                                        </Grid>
                                    ))}
                            </Grid>
                        </Box>

                        {/* Mostrar botón solo si no hay documentos visibles */}
                        {documents.filter(doc => !doc.hidden).length === 0 && (
                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                                <Button variant="contained" component="label">
                                    Subir archivo de cierre
                                    <input type="file" hidden onChange={handleFileChange} />
                                </Button>
                            </Box>
                        )}
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                            {/* boton de guardar archivo */}
                            <Button type="button" variant="contained" color="primary" sx={{ width: '150px', fontWeight: 'bold' }} onClick={handleSubmitDocReport}>
                                Guardar
                            </Button>
                            
                            {documents.some(doc => 
                                (doc.fileName || doc.name) === `PR-${idProposalProject}_requerimientos_iniciales_cierre.docx` && !doc.hidden
                            ) && (
                                <Button variant="contained" color="success" sx={{ width: '150px', fontWeight: 'bold', marginLeft: '10px' }} onClick={handleFinish}>
                                    Finalizar
                                </Button>
                            )}
                        </Box>
                    </>);
                } else {
                    showComponents = (
                        <Typography variant="h6" mt={4}>
                            Propuesta Aceptada
                        </Typography>
                    );
                }
                break;
            case ProposalProjectConstants.STATUS_REFUSED:
                showComponents = (
                    <Typography variant="h6" mt={4}>
                        Propuesta Rechazada
                    </Typography>
                );
                break;
            // Add new case for standby status
            case ProposalProjectConstants.STATUS_STANDBY:
                if (checkPermission(ADMIN_PROPOSAL_PROJECT)){
                    showComponents = (
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                            <Button 
                                variant="contained" 
                                color="primary" 
                                sx={{ width: '200px', fontWeight: 'bold' }} 
                                onClick={handleBackToFlow}
                            >
                                Volver al flujo
                            </Button>
                        </Box>
                    );
                } else {
                    showComponents = (
                        <Typography variant="h6" mt={4}>
                            Propuesta en espera
                        </Typography>
                    );
                }
                break;
            default:
                showComponents = (<>{proposalProjectStatus}</>);
                break;
        }
        
        return (<>
            {jiraEpicKey && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, mt: 2 }}>
                    <Button 
                        variant="contained" 
                        color="primary" 
                        href={`${process.env.REACT_APP_JIRA_BASE_URL}/browse/${jiraEpicKey}`} 
                        target="_blank"
                    >
                        Acceder al proyecto en JIRA: {jiraEpicKey}
                    </Button>
                </Box>
            )}
            {showComponents}
        </>);
    };

    return (
        <div style={{ backgroundColor: '#f5f5f5', padding: '20px', borderRadius: '8px', textAlign: 'center', marginTop: '20px', border: '1px solid #ccc' }}>
            <Box sx={{ p: 4 }}>

                <Typography variant="h6" mb={2}>
                    Vista ROI
                </Typography>

                {loadingRoi ? (
                    <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column',
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        p: 5, 
                        backgroundColor: '#e0f7fa', 
                        borderRadius: '8px',
                        minHeight: '300px'
                    }}>
                        <CircularProgress size={60} thickness={4} sx={{ mb: 2 }} />
                        <Typography variant="h6" color="text.secondary">
                            Cargando datos ROI...
                        </Typography>
                    </Box>
                ) : (
                    <Paper sx={{ p: 2, backgroundColor: '#e0f7fa', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)' }}>
                        <Grid container spacing={1}>
                            {/* Header */}
                            <Grid item xs={2} />
                            {['Año 1', 'Año 2', 'Año 3', 'Año 4', 'Año 5'].map((year, index) => (
                                <Grid key={index} item xs={2}>
                                    <Typography sx={headerStyle}>{year}</Typography>
                                </Grid>
                            ))}

                            {/* Filas dinámicas */}
                            {rows.map((row, rowIndex) => (
                                <React.Fragment key={rowIndex}>
                                    <Grid item xs={2}>
                                        <Typography
                                            sx={{
                                                ...headerStyle,
                                                backgroundColor: rowIndex % 2 === 0 ? '#1b8bdd' : '#6d8ba4',
                                            }}
                                        >
                                            {row.label}
                                        </Typography>
                                    </Grid>
                                    {[...Array(5)].map((_, colIndex) => {
                                        const yearKey = `year${colIndex + 1}`; // Generar la clave dinámica para el año
                                        const value = roiProposalProject[yearKey]?.[row.key] ?? 0; // Obtener el valor o 0 si no existe
                                        return (
                                            <Grid key={colIndex} item xs={2}>
                                                <Typography
                                                    sx={{
                                                        ...dataStyle,
                                                        backgroundColor: rowIndex % 2 === 0 ? '#ffffff' : '#c6c6c6',
                                                        padding: '8px',
                                                    }}
                                                >
                                                    {value.toFixed(2)}
                                                </Typography>
                                            </Grid>
                                        );
                                    })}
                                </React.Fragment>
                            ))}
                        </Grid>
                    </Paper>
                )}

                {renderButtons(proposalProjectStatus)}

                <Dialog open={openDialog} onClose={handleCloseDialog}>
                    <DialogTitle>Confirmar Eliminación</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            ¿Estás seguro de que deseas eliminar?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog} color="primary">
                            Cancelar
                        </Button>
                        <Button onClick={handleConfirmDelete} color="error">
                            Eliminar
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={openDialogError} onClose={handleCloseDialog}>
                    <DialogTitle>Error</DialogTitle>
                    <DialogContent>
                        <DialogContentText>Se debe rellenar todos los datos.</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog} color="primary" autoFocus>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>

                <DialogLoader open={sendingApiRequest || generatingPdf} />
                
            </Box>
        </div>
    );
};

FourthStep.propTypes = {
    idProposalProject: propTypes.number,
    proposalProjectStatus: propTypes.string,
    roiProposalProject: propTypes.object,
    permissionsProposalProject: propTypes.string,
    reloadData: propTypes.func,
    readOnly: propTypes.bool,
    currentStatus: propTypes.string,
    jiraEpicKey: propTypes.string // Add prop type for jiraEpicKey
};

export default FourthStep;
